export const CampusService ="/campus-service"